import styles from "./Kelly.module.css";

export default function Kelly() {
  return (
    <div className={styles.container}>
      <div className={styles.mimo}>
        <div>
          <div>Kelly</div>
          <div>HR Manager</div>
        </div>
      </div>
      <div className={styles.textBox}>
        <div className={styles.textList}>
          <div>먼데이오프는 끊임없이 변화하기 위해 노력합니다.</div>
          <br />
          <div>서로 의견을 경청하고, 더 새로운 방법을 찾기 위해 나아가요</div>
          <br />
          <div>
            혁신을 거듭하는 회사의 분위기는 어느새 나를 더 성장한 사람으로
            만듭니다.
          </div>
          <br />
          <div>Everyone, MondayOFF!</div>
          <br />
          <div>
            모두 우리의 게임과 문화를 즐기는 그 날을 함께 맞이하고 싶어요.
          </div>
          <br />
          <div>먼데이오프는 성장하고 싶은 인재를 기다립니다.</div>
          <br />
        </div>
        <div>Kelly/ HR Manager</div>
      </div>
    </div>
  );
}

/*
먼데이오프는 끊임없이 변화하기 위해 노력합니다.
서로 의견을 경청하고, 더 새로운 방법을 찾기 위해 나아가요
혁신을 거듭하는 회사의 분위기는 어느새 나를 더 성장한 사람으로 만듭니다.
Everyone, MondayOFF!
모두 우리의 게임과 문화를 즐기는 그 날을 함께 맞이하고 싶어요.
먼데이오프는 성장하고 싶은 인재를 기다립니다
*/
